import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import GlobalStyle from "./GlobalStyle";
import { AuthProvider } from "./AuthContext";
import { LanguageProvider } from "./LanguageContext";
import { CurrencyProvider } from "./CurrencyContext";
import Home from "./Home";
import AboutUs from "./AboutUs";
import TigerWoods from "./TigerWoods";
import RoryMcIlroy from "./RoryMcIlroy";
import CollinMorikawa from "./CollinMorikawa";
import Register from "./Register";
import LogIn from "./LogIn";
import ForgotPassword from "./ForgotPassword";
import Subscription from "./Subscription";
import AiMentors from "./AiMentors";
import Terms from "./legal/Terms";
import Privacy from "./legal/Privacy";
import Consent from "./legal/Consent";
import TermsEn from "./legal/TermsEn";
import PrivacyEn from "./legal/PrivacyEn";
import ConsentEn from "./legal/ConsentEn";

function App() {
  return (
    <LanguageProvider>
    <CurrencyProvider>
    <AuthProvider>
    <Router>
      <GlobalStyle />
      <Routes>
        <Route path="/"              element={<Home />} />
        <Route path="/analysis"      element={<AiMentors />} />
        <Route path="/mentors"       element={<Navigate to="/analysis" replace />} />
        <Route path="/about"         element={<AboutUs />} />
        <Route path="/tiger-woods"   element={<TigerWoods />} />
        <Route path="/rory-mcilroy"  element={<RoryMcIlroy />} />
        <Route path="/collin-morikawa" element={<CollinMorikawa />} />
        <Route path="/register"      element={<Register />} />
        <Route path="/log-in"        element={<LogIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/premium"       element={<Subscription />} />
        <Route path="/premium/success" element={<Subscription />} />
        <Route path="/premium/failed"  element={<Subscription />} />
        <Route path="/successful-payment" element={<Navigate to="/premium/success" replace />} />
        <Route path="/failed-payment"     element={<Navigate to="/premium/failed" replace />} />
        <Route path="/legal/terms"      element={<Terms />} />
        <Route path="/legal/privacy"    element={<Privacy />} />
        <Route path="/legal/consent"    element={<Consent />} />
        <Route path="/legal/terms-en"   element={<TermsEn />} />
        <Route path="/legal/privacy-en" element={<PrivacyEn />} />
        <Route path="/legal/consent-en" element={<ConsentEn />} />
      </Routes>
    </Router>
    </AuthProvider>
    </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;
